import React from "react";
import AppProviders from "./src/services/appProviders";

export const wrapRootElement = ({ element }) => (
    <AppProviders>{element}</AppProviders>
)